module.exports = __webpack_public_path__ + "static/img/bgtwo.2702a28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bgtwo.png
// module id = qv/+
// module chunks = 1